/* global Excel */

import { MAX_CELLS_TO_SCAN_FOR_CONTENT } from "../taskpane.constants";

export function isBlankExcelCell(cell: unknown): boolean {
  if (cell === null || cell === undefined) {
    return true;
  }
  if (typeof cell === "string") {
    return cell.trim() === "";
  }
  return false;
}

/**
 * Uses the active worksheet’s used range (Office.js) before fetch. Empty sheets yield a null used range.
 * For modest used areas, scans cell values so formatting-only ranges do not open the overwrite modal.
 */
export async function detectActiveSheetHasCellContent(): Promise<{
  sheetName: string;
  hasContent: boolean;
}> {
  return Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    sheet.load("name");
    const used = sheet.getUsedRangeOrNullObject();
    used.load(["isNullObject", "rowCount", "columnCount"]);
    await context.sync();

    const sheetName = sheet.name;

    if (used.isNullObject) {
      return { sheetName, hasContent: false };
    }

    const rowCount = used.rowCount;
    const columnCount = used.columnCount;
    const cellCount = rowCount * columnCount;

    if (cellCount <= MAX_CELLS_TO_SCAN_FOR_CONTENT) {
      used.load("values");
      await context.sync();
      const values = used.values as unknown[][];
      const hasContent = values.some(
        (row) => Array.isArray(row) && row.some((cell) => !isBlankExcelCell(cell)),
      );
      return { sheetName, hasContent };
    }

    return { sheetName, hasContent: true };
  });
}
